




import Vue from 'vue';
export default Vue.extend({
    computed: {
        emailType() {
            if (!(this as any).params || !(this as any).params.data) {
                return '';
            }
            if ((this as any).params.data.emailDateDelivered) {
                return 'Delivered';
            }

            if ((this as any).params.data.emailDateDropped) {
                return 'Dropped';
            }

            if ((this as any).params.data.emailDateBounced) {
                return 'Bounced';
            }

            if ((this as any).params.data.emailDateDeferred) {
                return 'Deferred';
            }
        },
    },
});
